// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"6f60a677","882":"fc0b604e"}[chunkId] + ".chunk.js";
};